import { render, staticRenderFns } from "./FamilyRegister.vue?vue&type=template&id=66888c6c&scoped=true&lang=pug"
import script from "./FamilyRegister.vue?vue&type=script&lang=ts"
export * from "./FamilyRegister.vue?vue&type=script&lang=ts"
import style0 from "./FamilyRegister.vue?vue&type=style&index=0&id=66888c6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66888c6c",
  null
  
)

export default component.exports